import { F0Box } from '@factorialco/f0-react'

import { MicrophoneButton } from './components/MicrophoneButton'
import { PreConnectMicrophoneButton } from './components/PreConnectMicrophoneButton'
import { SessionActionButton } from './components/SessionActionButton'
import { SettingsButton } from './components/SettingsButton'

interface ControlBarProps {
  connected: boolean
  connecting: boolean
  onConnect: () => void
  onDisconnect: () => void
}

export const ControlBar = ({ connected, connecting, onConnect, onDisconnect }: ControlBarProps) => {
  return (
    <F0Box display="flex" alignItems="center" justifyContent="center" gap="md" marginBottom="5xl">
      {connected ? <MicrophoneButton /> : <PreConnectMicrophoneButton />}
      <SettingsButton />
      <SessionActionButton
        connected={connected}
        connecting={connecting}
        onConnect={onConnect}
        onDisconnect={onDisconnect}
      />
    </F0Box>
  )
}
